import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { TourProvider } from "@reactour/tour";
import TutorialModal, { steps } from "./Tutorial";

function TutorialWrapper({ children }) {
  const location = useLocation();
  const history = useHistory();
  const [step, setStep] = useState(0);

  const handleSteps = (step) => {
    switch (step) {
      case 0:
        localStorage.setItem('openedTutorial', true);
        if (location.pathname !== "/matriz") {
          history.push("/matriz");
        }
        break;
      case 5:
        if (location.pathname !== "/matriz") {
          history.push("/matriz");
        }
        break;
      case 6:
        if (location.pathname !== "/simulador") {
          history.push("/simulador");
        }
        break;
      case 9:
        localStorage.setItem('openedTutorial', true);
        break;
      default:
        break;
    }
    setStep(step);
  };

  return (
    <TourProvider
      steps={steps}
      currentStep={step}
      setCurrentStep={handleSteps}
      components={{ Content: TutorialModal }}
      showBadge={false}
      showDots={false}
      showCloseButton={false}
      showNavigation={false}
      scrollSmooth
      styles={{
        popover: (base) => ({
          ...base,
          maxWidth: "none",
          borderRadius: "12px",
          margin: "0",
          padding: "0",
        }),
      }}
    >
      {children}
    </TourProvider>
  );
}

export default TutorialWrapper;
